import React from 'react';
// import sImage from "../components/images/s.jpg";
import { useNavigate } from "react-router-dom";

import pro from "../components/images/pro.jpg";
import Plus from "../components/images/plus.jpg";
import imac from "../components/images/Imac.jpg";
import "animate.css";
import d1 from "../components/images/d1.gif";
import d2 from "../components/images/d2.gif";
import d3 from "../components/images/d3.gif";

// import d4 from "../components/images/Remote management d1.gif";
// import d5 from "../components/images/Network d1.gif";
// import d6 from "../components/images/camera d2.gif";
// import d7 from "../components/images/location d1.gif";
// import d8 from "../components/images/control d1.gif";
// import d9 from "../components/images/Device d1.gif";

import d10 from "../components/images/Payme d1.gif";
import d11 from "../components/images/Improved d1.gif";
import d12 from "../components/images/Efficiency d1.gif";
import sImage1 from "../components/images/speaker1.jpg";
import sImage4 from "../components/images/Banner 1.jpg";
import sImage2 from "../components/images/TCOPS IMAC.jpeg";
import sImage3 from "../components/images/speaker3.jpg";

import "./Tcops.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const bannerImages = [sImage4, sImage2, sImage3];


const product = [pro,Plus,imac];
const Tcops = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    pauseOnHover: false
  };
  const navigate = useNavigate();

  return (
    <div className="tcops-container">

      {/* Banner Slider */}
      <div className="tcops-slider">
        <Slider {...settings}>
          {bannerImages.map((image, index) => (
            <div key={index}>
              <img src={image} alt={`Banner ${index + 1}`} className="slider-image" />
            </div>
          ))}
        </Slider>
      </div>

      {/* India No.1 Banner */}
      <div className="tcops-top-banner">
  <span>In Proudly India's No.1 Finance Locker — Trusted By Millions Across The Nation!</span>
</div>


      {/* Intro */}
      <div className="tcops-intro">
        <h1>Our Product: <span className="highlight">T-Cops</span></h1>
        <p>
  T-COPS is a cutting-edge security and surveillance solution built for next-generation operations, offering three advanced variants designed to meet diverse professional requirements.
</p>

        {/* <p>
          T-Cops is a state-of-the-art security and surveillance solution designed for next-gen operations. 
          Discover our three advanced variants tailored for different professional needs.
        </p> */}
      </div>

      {/* Product Types */}
      {/* <div className="tcops-products">
        <div className="product-card">
          <h2>T-Cops zt Pro</h2>
          <p  style={{ color: "white",fontWeight: "bold" }}>
            Designed for enterprise-grade environments, ZT Pro offers AI-powered monitoring, real-time alerts, and seamless integration with modern systems.It is use for New Phone .
          </p>
        </div>
        <div className="product-card">
          <h2>T-Cops zt Plus</h2>
          <p style={{ color: "white",fontWeight: "bold" }}>
            Perfect for mid-sized organizations, ZT Plus balances performance and affordability while maintaining top-tier security capabilities.It is used for old phone and Already finence .
          </p>
        </div>
        <div className="product-card">
          <h2>T-Cops zt iMac</h2>
          <p style={{ color: "white",fontWeight: "bold" }}>
            Engineered for creative professionals and Mac environments, ZT iMac combines intuitive design with robust protection tools.It is used for iPhone .
          </p>
        </div> 
      </div> */}
<div className="tcops-products">
  
  <div className="product-card">
    <h2>T-COPS ZT Pro</h2>
    <p style={{ color: "white", fontWeight: "bold" }}>
      Designed for enterprise-grade environments, delivering AI-powered monitoring, real-time alerts, 
      and seamless integration with modern systems. Built for high-end operations, it ensures maximum 
      security and efficiency while remaining fully compatible with new devices.
    </p>
  </div>

  <div className="product-card">
    <h2>T-COPS ZT Plus</h2>
    <p style={{ color: "white", fontWeight: "bold" }}>
      Ideal for mid-sized organizations, striking the perfect balance between performance and affordability. 
      It maintains top-tier security capabilities while being optimized for use with older devices, 
      making it a reliable and cost-effective solution.
    </p>
  </div>

  <div className="product-card">
    <h2>T-COPS ZT Mac</h2>
    <p style={{ color: "white", fontWeight: "bold" }}>
      Engineered for creative professionals and modern work environments. It combines an intuitive design 
      with robust protection tools, offering a secure yet user-friendly experience tailored for I Phone users.
    </p>
  </div>

</div>




 
{/*        
 <section className="v1"style={{ background : "white" }}>
        <h2 className="h1" style={{color:'black'}}><span className="highlight">The TCOPS Finance Locker</span> – Our Flagship Product</h2>
        <p className="about-us-container">
          At the core of our success is TCOPS Finance Locker, an advanced mobile
          security application designed specifically for the telecom industry. Unlike
          traditional security apps, TCOPS Finance Locker addresses the unique
          challenges faced by the mobile market when customers delay or default on
          EMI payments. This solution empowers financial institutions to monitor and
          control mobile assets with unparalleled precision.
        </p>
        <br />

        <section className="card1">
          <div className="card">
            <img style={{ width: '50%' }} src="/assets/Cross.png" alt="" />
            <h5 style={{ fontSize: 'x-large' }}>Cross-Platform Versatility</h5>
            <p>Available on Android, iOS, and compatible with refurbished devices.</p>
          </div>
          <div className="card">
            <img style={{ width: '50%' }} src="/assets/Comprehensive.png" alt="" />
            <h5 style={{ fontSize: 'x-large' }}>Comprehensive Control</h5>
            <p>Enables remote device management, mitigating unauthorized usage and risk.</p>
          </div>
          <div className="card">
            <img style={{ width: '50%' }} src="/assets/Tailored.png" alt="" />
            <h5 style={{ fontSize: 'x-large' }}>Tailored Security</h5>
            <p>
              Designed specifically for financial institutions, telecom sector & handset
              industry, combining robust technology with user-centric features.
            </p>
          </div>
        </section>
      </section> */}



 {/* <section className="v1" style={{ background: "white" }}>
  <h2 className="h1" style={{ color: 'black' }}>
    <span className="highlight">The T-Cops Finance Locker</span> – Our Flagship Product
  </h2>
  <p className="about-us-container">
    At the core of our success is T-Cops Finance Locker, an advanced mobile
    security application designed specifically for the telecom industry. Unlike
    traditional security apps, T-Cops Finance Locker addresses the unique
    challenges faced by the mobile market when customers delay or default on
    EMI payments. This solution empowers financial institutions to monitor and
    control mobile assets with unparalleled precision.
  </p>
  <br />

  <section className="card1">
    <div className="card">
      <figure style={{ textAlign: "center" }}>
        <img style={{ width: '50%' }} src={d3} alt="Cross-Platform" />
        <figcaption>Cross-Platform Versatility</figcaption>
      </figure>
      <h5 style={{ fontSize: 'x-large' }}>Cross-Platform Versatility</h5>
      <p>Available on Android, iOS, and compatible with refurbished devices.</p>
    </div>

    <div className="card">
      <figure style={{ textAlign: "center" }}>
        <img style={{ width: '50%' }}  src={d2} alt="Comprehensive Control" />
        <figcaption>Comprehensive Control</figcaption>
      </figure>
      <h5 style={{ fontSize: 'x-large' }}>Comprehensive Control</h5>
      <p>Enables remote device management, mitigating unauthorized usage and risk.</p>
    </div>

    <div className="card">
      <figure style={{ textAlign: "center" }}>
        <img style={{ width: '50%' }} src={d1} alt="Tailored Security" />
        <figcaption>Tailored Security</figcaption>
      </figure>
      <h5 style={{ fontSize: 'x-large' }}>Tailored Security</h5>
      <p>
        Designed specifically for financial institutions, telecom sector & handset
        industry, combining robust technology with user-centric features.
      </p>
    </div>
  </section>
</section>  */}


<section className="v1" style={{ background: "white" }}>
  <h2 className="h1" style={{ color: "black" }}>
    <span className="highlight">The T-COPS Finance Locker</span> – Our Flagship Product
  </h2>

  <p className="about-us-container">
    At the core of our success is T-COPS Finance Locker, an advanced mobile security
    application purpose-built for the telecom and financial ecosystem. Unlike
    conventional security solutions, it directly addresses the challenges of
    EMI-based device financing by empowering institutions to monitor, manage,
    and control mobile assets with unmatched precision.
  </p>

  <br />

  <section className="card1">

    {/* Cross-Platform Versatility */}
    <div className="card">
      <figure style={{ textAlign: "center" }}>
        <img style={{ width: "50%" }} src={d3} alt="Cross-Platform Versatility" />
        <figcaption>Cross-Platform Versatility</figcaption>
      </figure>
      <h5 style={{ fontSize: "x-large" }}>Cross-Platform Versatility</h5>
      <p>
        Available on Android, iOS and compatible refurbished devices.
      </p>
    </div>

    {/* Comprehensive Remote Control */}
    <div className="card">
      <figure style={{ textAlign: "center" }}>
        <img style={{ width: "50%" }} src={d2} alt="Comprehensive Remote Control" />
        <figcaption>Comprehensive Remote Control</figcaption>
      </figure>
      <h5 style={{ fontSize: "x-large" }}>Comprehensive Remote Control</h5>
      <p>
        Enable remote device management by mitigating unauthorized usage and risk.
      </p>
    </div>

    {/* Tailored Security (Remain Same) */}
    <div className="card">
      <figure style={{ textAlign: "center" }}>
        <img style={{ width: "50%" }} src={d1} alt="Tailored Security" />
        <figcaption>Tailored Security</figcaption>
      </figure>
      <h5 style={{ fontSize: "x-large" }}>Tailored Security</h5>
      <p>
        Designed specifically for financial institutions, telecom sector & handset
        industry, combining robust technology with user-centric features.
      </p>
    </div>

  </section>
</section>





      {/* Detailed Section for Each Product */}


   




      
      {/* Why Choose Tcops */}
      {/* <div className="tcops-why animate__animated animate__fadeIn">
        <h2>Why Choose Tcops?</h2>
        <p>
          Tcops is more than a product — it's a revolution in digital security. 
          As India's leading finance locker and surveillance solution, Tcops brings you unmatched reliability, speed, and peace of mind.
        </p>
        <ul>
          <li>✅ ISO-certified security protocols</li>
          <li>🚀 Lightning-fast cloud sync</li>
          <li>🌐 24/7 support & updates</li>
          <li>📱 Compatible with Android, iOS, Windows & Mac</li>
        </ul>
      </div> */}







 <div>


       
      <section className="expansion-container">
        <h2 className="about-us-headinga" style={{color:'white'}}>Distinctive Features <span className="highlight">Without Repetition</span></h2>
        {/* <p className="about-us-container">
          T-COPS Finance Locker delivers comprehensive mobile security through a powerful suite of intelligent features
designed to protect assets at every level.
        </p> */}

        <div className="card-grid">
          <div className="expansion-card">
            <img style={{ width: '50%' }} src="/assets/DeviceManagement.svg" alt="" />
            <h5 style={{ fontSize: 'x-large' }}>Remote device management</h5>
            <p>
              Allows instant locking or unlocking of devices, ensuring immediate actionON EMI delays or defaults.
            </p>
          </div>

          <div className="expansion-card">
            <img style={{ width: '33%' }} src="/assets/Application Control.png" alt="" />
            <h5 style={{ fontSize: 'x-large' }}>Selective Application Control</h5>
            <p>Restricts access to sensitive applications, preventing unauthorized usage.</p>
          </div>

          <div className="expansion-card">
            <img style={{ width: '50%' }} src="/assets/camera.png" alt="" />
            <h5 style={{ fontSize: 'x-large' }}>Integrated Camera Control</h5>
            <p>Disables the camera to enhance privacy and prevent unauthorized image capture.</p>
          </div>
        </div>

        <div className="card-grid">
          <div className="expansion-card">
            <img style={{ width: '35%' }} src="/assets/networking.png" alt="" />
            <h5 style={{ fontSize: 'x-large' }}>Dynamic SIM and Network Monitoring</h5>
            <p>Tracks real-time SIM changes to reinforce fraud prevention.</p>
          </div>

          <div className="expansion-card">
            <img style={{ width: '35%' }} src="/assets/location1.png" alt="" />
            <h5 style={{ fontSize: 'x-large' }}>Advanced Location Services</h5>
            <p>Enables precise device tracking both online and offline.</p>
          </div>

          <div className="expansion-card">
            <img style={{ width: '35%' }} src="/assets/Proactive Device.png" alt="" />
            <h5 style={{ fontSize: 'x-large' }}>Proactive Device Maintenance</h5>
            <p>
              Controls Wi-Fi, Bluetooth, and airplane mode for complete security oversight.
            </p>
          </div>
        </div>
      </section> 

      






<section className="expansion-container" style={{ background: "white" }}>
  <h2 className="about-us-headinga" style={{ color: 'black' }}>
    <span className="highlight">Advancing Company Success</span> and  Market Leadership
  </h2>
  <p className="about-us-container">
   Our technology-driven solutions deliver measurable business growth while strengthening competitive
positioning in the market.
  </p>

  <div className="card-grid">
    <div className="expansion-card">
      <img style={{ width: '35%' }} src={d10} alt="Enhanced Payment Recovery" />
      <h5 style={{ fontSize: 'x-large', color: 'black' }}>Strong Financial Performance</h5>
      <p style={{ color: 'black' }}>
       Optimized recovery systems reduce risk, improve cash flow, and
enhance overall profitability.
      </p>
    </div>

    <div className="expansion-card">
      <img style={{ width: '35%' }} src={d11} alt="Improved Compliance" />
      <h5 style={{ fontSize: 'x-large', color: "black" }}>Customer-centric Growth</h5>
      <p style={{ color: 'black' }}>
       Reliable systems and transparent processes increase customer confidence, retention, and long-term business.
      </p>
    </div>

    <div className="expansion-card">
      <img style={{ width: '35%' }} src={d12} alt="Operational Efficiency" />
      <h5 style={{ fontSize: 'x-large', color: 'black' }}>Reliable After-Sales Service</h5>
      <p style={{ color: 'black' }}>
         Dedicated support team ensuring prompt assistance and customer
satisfaction. 
      </p>
    </div>
  </div>
</section>






    </div>

    
      {/* Call to Action */}
      {/* <div className="tcops-cta animate__animated animate__bounceIn">
        <h2>Ready to experience India’s No.1 Finance Locker?</h2>
        <button className="cta-button">Get Started with T-Cops Today</button>
      </div> */}
      <div className="tcops-cta animate__animated animate__bounceIn">
  <h2>Ready to experience India’s No.1 Finance Locker?</h2>

  <button
    className="cta-button"
    onClick={() => navigate("/contact")}
  >
    Get Started with T-Cops Today
  </button>
</div>

    </div>
  );
};

export default Tcops;
